<template>
	<div>
		<v-textarea
			class="mt-2 no-line"
			label="メモ"
			outlined
			dense
			v-model="memo_data.content"
			no-resize
			readonly
			persistent-hint
			rows="1"
			:hint="`${allFiles > 0 ? `${allFiles}件の添付ファイルがあります。` : '添付ファイルはありません。'}自身の作成したメモのみ編集可能です。`"
		>
			<template v-slot:append-outer>
				<v-btn icon class="ml-2" @click="detailDialog = true"><v-icon>mdi-information</v-icon></v-btn>
			</template>
		</v-textarea>
		<v-dialog
			v-model="detailDialog"
			max-width="700px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary" tag="div">
					<v-app-bar-title class="color-white">メモ詳細</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="detailDialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>
				<div class="pa-2">
          <h4 class="mt-2 text-body-1 font-weight-bold">内容</h4>
					<p v-text="memo_data.content" />
          <h4 class="mt-4 text-body-1 font-weight-bold">添付ファイル</h4>
					<div class="file-area">
						<span v-if="allFiles < 1" class="filename text-body-2">添付ファイルはありません。</span>
						<template v-else>
							<v-chip class="mr-1 mt-2" label outlined color="primary" v-for="file in memo_data.existing_files" :key="file.id">
								<v-icon class="mr-1">mdi-paperclip</v-icon>
								{{ file.name }}
							</v-chip>
						</template>
					</div>
				</div>
				<v-card-actions>
					<v-row no-gutters justify="end">
						<v-btn color="grey darken-1" text @click="detailDialog = false"> 閉じる </v-btn>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import common from "../../helper/common"

export default {
	props: {
		memo_data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			detailDialog: false,
			common: common,
		}
	},
	computed: {
		allFiles() {
			return this.memo_data.files.length + (this.memo_data.existing_files ? this.memo_data.existing_files?.length : 0)
		},
	},
}
</script>
